import { Col } from 'reactstrap';

const PracticeGroup = ({ practiceGroupName }) => {
    if (!practiceGroupName) return [];
    return (
        <Col sm="12">
            <p>
                <span>
                    <span className="op-6">Group</span>&emsp;
                    {practiceGroupName}
                </span>
            </p>
        </Col>
    );
};

export default PracticeGroup;
